import { motion } from 'framer-motion';
import { SectionHeader } from './Services';

const steps = [
  { n: '01', title: 'Välj aktivitet', text: 'Bläddra bland 600+ borgar och spel.', color: 'bg-tomato' },
  { n: '02', title: 'Boka datum', text: 'Skicka förfrågan eller ring oss direkt.', color: 'bg-sun' },
  { n: '03', title: 'Bekräfta bokning', text: 'Vi går igenom din förfrågan och kontaktar dig för att bekräfta detaljer och säkra ditt datum.', color: 'bg-grape' },
  { n: '04', title: 'Hämta eller leverans', text: 'Vi kör hem den eller du hämtar själv.', color: 'bg-sky' },
  { n: '05', title: 'Ha kul!', text: 'Studsa loss — vi tar hand om resten.', color: 'bg-grass' },
];

export default function HowItWorks() {
  return (
    <section className="relative py-16 sm:py-20 bg-sand">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <SectionHeader
          eyebrow="Så funkar det"
          title={<>Fem steg till <span className="text-tomato">festens</span> höjdpunkt.</>}
          description="Inga krångliga formulär eller långa väntetider. Vi hjälper dig att hitta rätt aktivitet och få allt på plats — snabbt."
        />

        <div className="mt-14 relative">
          {/* Connector line */}
          <div className="hidden lg:block absolute top-12 left-0 right-0 h-0.5 bg-ink/10" />
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-6 lg:gap-4">
            {steps.map((s, i) => (
              <motion.div
                key={s.n}
                initial={{ opacity: 0, y: 24 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: i * 0.1 }}
                className="relative"
              >
                <motion.div
                  whileHover={{ scale: 1.08, rotate: -4 }}
                  transition={{ type: 'spring', stiffness: 300 }}
                  className={`relative z-10 mx-auto size-24 rounded-full ${s.color} text-cream grid place-items-center shadow-bouncy ring-8 ring-cream`}
                >
                  <span className="font-display text-3xl font-bold">{s.n}</span>
                </motion.div>
                <div className="mt-6 text-center">
                  <h3 className="font-display text-2xl font-semibold">{s.title}</h3>
                  <p className="mt-2 text-ink/65 text-pretty max-w-[18rem] mx-auto">{s.text}</p>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
